(() => {
  'use strict';
  const form = document.querySelector('#form-contact');
  if (!form || form.dataset.contactReady) return;
  form.dataset.contactReady = 'true';
  const button = form.querySelector('[data-contact-submit]');
  const label = button?.textContent;
  let timer;
  function reset() {
    clearTimeout(timer);
    if (button) { button.disabled = false; button.removeAttribute('aria-disabled'); button.textContent = label; }
    form.removeAttribute('aria-busy');
  }

  const message = form.querySelector('[data-contact-form-message]');
  if (message) message.focus();

  form.addEventListener('submit', () => {
    if (!button || !form.checkValidity()) return;
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = button.dataset.loadingLabel || button.textContent;
    form.setAttribute('aria-busy', 'true');
    timer = setTimeout(reset, 12000);
  });
  window.addEventListener('pageshow', reset);
})();
